import {
  PaymentFrequenciesType,
  SelectOption,
} from 'QuoteApp/services/endpoints/GetConfig';
import { FlexiblePaymentFrequency } from 'QuoteApp/services/endpoints/GetPaymentDetails';
import { MONTHS, WEEK_DAYS, WeekDayType } from 'Shared/constants/date';
import { formatText } from 'Shared/utils';

export const getNextDayWithSelectedDay = (
  selectedDay: string,
  effectiveDate: string,
  instance: number = 1
): string | null => {
  const effectiveDateObj = new Date(effectiveDate);
  const selectedDayIndex = WEEK_DAYS.indexOf(selectedDay as WeekDayType);

  if (selectedDayIndex === -1) {
    return null;
  }

  const effectiveDayIndex = effectiveDateObj.getUTCDay();
  const daysUntilNextSelectedDay =
    (selectedDayIndex - effectiveDayIndex + 7) % 7 || 7;

  effectiveDateObj.setUTCDate(
    effectiveDateObj.getUTCDate() +
      daysUntilNextSelectedDay +
      (instance - 1) * 7
  );

  const dayOfWeek = WEEK_DAYS[effectiveDateObj.getUTCDay()];
  const month = MONTHS[effectiveDateObj.getUTCMonth()];
  const dayOfMonth = effectiveDateObj.getUTCDate();

  return `${dayOfWeek}, ${month} ${dayOfMonth}`;
};

export const getConfigByFrequency = (
  frequency: FlexiblePaymentFrequency,
  paymentFrequencies: PaymentFrequenciesType = []
) => {
  const frequencyConfig = paymentFrequencies.find(
    configItem => configItem.name === frequency
  );
  if (!frequencyConfig) return [];
  return frequencyConfig.options;
};

export const buildWeekdaySelectorData = (
  paymentFrequencies?: PaymentFrequenciesType
): Array<SelectOption<string>> => {
  return getConfigByFrequency('weekly', paymentFrequencies) as Array<
    SelectOption<string>
  >;
};

export const buildBiweeklyDateSelectorData = (
  dayOfWeek?: string,
  startDate?: string
): Array<SelectOption<string>> => {
  if (!dayOfWeek) return [];

  const capitalizedSelectedDay = formatText(dayOfWeek, 'capitalize');

  return Array.from({ length: 2 }, (_, index) => {
    const instance = index + 1;
    return {
      value: `${dayOfWeek}_${instance}`,
      label:
        getNextDayWithSelectedDay(
          capitalizedSelectedDay,
          startDate || '',
          instance
        ) ?? '',
    };
  });
};

export const buildSemiMonthlySelectorData = (
  paymentFrequencies?: PaymentFrequenciesType
): Array<SelectOption<string>> => {
  const semiMonthlyConfig = getConfigByFrequency(
    'semiMonthly',
    paymentFrequencies
  ) as Array<SelectOption<Array<number>>>;

  return semiMonthlyConfig.map(option => {
    const [day1, day2] = option.value;
    const value = `${day1},${day2}` as const;

    return {
      label: option.label,
      value,
    };
  });
};

export const buildMonthlySelectorData = (
  paymentFrequencies?: PaymentFrequenciesType
): Array<SelectOption<string>> => {
  const monthlyConfig = getConfigByFrequency(
    'monthly',
    paymentFrequencies
  ) as Array<SelectOption<number>>;

  return monthlyConfig.map(option => {
    return {
      label: option.label,
      value: option.value.toString(),
    };
  });
};
